import { createFileRoute } from "@tanstack/react-router"
import { Backoffice } from "modules/backoffice/components"

export const Route = createFileRoute("/_base/_auth/backoffice/")({
  component: Backoffice,
})
